import { render, staticRenderFns } from "./CompensationPoint.vue?vue&type=template&id=befefcc4&"
import script from "./CompensationPoint.vue?vue&type=script&lang=js&"
export * from "./CompensationPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports